import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs/index';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import {
    BsModalConfirmComponent,
    ConfirmDialogResult,
    createConfirmModalOptions
} from '../../../../core/modal/modal-confirm.component';
import { StrategyService } from '../../state/strategy.service';
import { GlobalSettingsActions } from './global-settings.actions';
import { GlobalSettingsService } from './global-settings.service';

@Injectable()
export class GlobalSettingsEffects {
    constructor(
        private actions$: Actions,
        private strategyService: StrategyService,
        private modalService: BsModalService,
        private globalSettingsService: GlobalSettingsService
       // private accountSettingService: AccountSettingService
    ) {

    }

    getAccountSettingsLoggedInUser$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(GlobalSettingsActions.getAccountSettingsLoggedInUser),
                switchMap(() =>
                    // TODO:  Use Account Setting Service when we return Observable form it
                    this.globalSettingsService.getAccountSettingsByName()
                        .pipe(
                            map((payload: any) =>
                                GlobalSettingsActions
                                    .getAccountSettingsLoggedInUserSuccess({
                                        statusFromSatellite: payload.settings.statusFromSatellite === 1,
                                        statusToSatellite: payload.settings.statusToSatellite === 1,
                                        strategyId: payload.settings.strategyId,
                                        clientModuleType: payload.settings.clientModuleType
                                    })
                            )
                        )
                )
                )
            );

    saveSatelliteStatusToFrom$ = createEffect(() => this.actions$
        .pipe(
            ofType(GlobalSettingsActions.saveSatelliteStatusToFrom),
            switchMap((action: any) =>
                this.globalSettingsService.saveSatelliteStatusToFrom(action.statusToSatellite, action.statusFromSatellite)
                    .pipe(
                        map((payload: any) =>
                                GlobalSettingsActions.saveSatelliteStatusToFromSuccess({
                                    statusToSatellite: action.statusToSatellite,
                                    statusFromSatellite: action.statusFromSatellite})
                        )
                    )
            )
        )
    );

    attemptSaveAccountStrategy$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(GlobalSettingsActions.attemptSaveAccountStrategy),
            mergeMap(({strategyId}) =>
                this.globalSettingsService.getEstimatedAppointmentsAffected(strategyId)
                    .pipe(
                        map((response: any) => {
                            const dialogMessage = `This change will affect ${response.estimatedAffected} appointments.
                                    Are you sure you want to make this change?`;

                            return GlobalSettingsActions.openConfirmDialog({
                                dialogMessage,
                                strategyId
                            });

                        })
                        // TODO: Handle when getting estimate fails
                    )
            )
        )
    );

    openConfirmDialog$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(GlobalSettingsActions.openConfirmDialog),
                switchMap(({dialogMessage, strategyId}) => {
                        const message = dialogMessage;
                        const title = 'Confirm';
                        const data: any = { strategyId };
                        const modalRef = this.modalService
                            .show(BsModalConfirmComponent, createConfirmModalOptions(title, message, 'Yes', 'No', data));

                        return modalRef.content.onClose;
                }),
                map((dialogResult: ConfirmDialogResult) => { // map dialog result into action (map function returns observable to action)
                    if (dialogResult.isConfirmed) {
                        return GlobalSettingsActions.saveAccountStrategy({strategyId: dialogResult.data.strategyId});
                    }

                    // Used cancelled saving
                    return GlobalSettingsActions.openConfirmDialogCancel();
                })
            )
    );

    saveAccountStrategy$: Observable<Action> = createEffect(() =>
        this.actions$
            .pipe(
                ofType(GlobalSettingsActions.saveAccountStrategy),
                mergeMap(({strategyId}) =>

                    this.globalSettingsService.saveAccountStrategy(strategyId)
                        .pipe(
                            map((response: any) =>
                                GlobalSettingsActions.saveAccountStrategySuccess({
                                    strategyId})
                            )
                            // TODO: Handle error saving
                        )
                )
            )
    );
}
